<div class="main-content detail-page">
  <div class="container-fluid p-0">
    <section class="card detail-surface m-1 mb-2">
      <div class="card-body p-3">
        <div class="d-flex flex-wrap align-items-start justify-content-between">
          <div class="mb-1">
            <h1 class="detail-title mb-1 pl-3">{{ detailProject.title }}</h1>

            <div class="d-flex flex-wrap align-items-center header-meta pl-3">
              <div class="d-flex align-items-center mr-4">
                <img
                  [src]="detailProject.leadAvatar"
                  [alt]="detailProject.lead"
                  class="meta-avatar rounded-circle"
                />
                <div class="ml-2">
                  <div class="meta-label text-uppercase font-weight-bold text-muted">Lider del proyecto</div>
                  <div class="meta-value font-weight-bold">{{ detailProject.lead }}</div>
                </div>
              </div>

              <div class="mb-1">
                <div class="meta-label text-uppercase font-weight-bold text-muted">ID proyecto</div>
                <div class="meta-value font-weight-bold">{{ detailProject.idProyecto }}</div>
              </div>

              <div class="mb-1">
                <div class="meta-label text-uppercase font-weight-bold text-muted">Inicio- Fin</div>
                <div class="meta-value font-weight-bold">{{ detailProject.duration }}</div>
              </div>
            </div>
          </div>

          <div class="d-flex align-items-center flex-wrap action-row">
            <a
              [routerLink]="['/seguimiento']"
              [queryParams]="returnQueryParams"
              class="btn action-btn mb-2"
            >
              <mat-icon class="action-btn__icon">arrow_back</mat-icon>
              <span>Volver</span>
            </a>
          </div>
        </div>

        <div class="row">
          <div class="col-12 col-xl-8 mb-2">
            <div class="card info-panel h-100 mt-0">
              <div class="card-body p-3">
                <div class="d-flex align-items-start justify-content-between mb-2">
                  <div>
                    <h2 class="panel-title mb-0 font-weight-bold">Resumen de progreso</h2>
                    <p class="panel-subtitle mb-0 text-muted">
                      {{ detailProject.plannedLabel }}
                    </p>
                  </div>

                  <div class="text-right">
                    <div class="progress-number">{{ detailProject.realProgress }}%</div>
                    <div class="progress-note">{{ detailProject.scheduleNote }}</div>
                  </div>
                </div>

                <!-- ── Stepper de fase (read-only) ── -->
                <div class="detail-stepper mb-3">
                  <ng-container *ngFor="let f of FASES; let last = last">
                    <div class="detail-step"
                         [class.detail-step--active]="detailProject.currentFase === f.value"
                         [class.detail-step--done]="isFasePasada(f.value)"
                         [ngStyle]="stepStyle(f.value)">
                      <div class="detail-step__circle">
                        <mat-icon class="detail-step__icon">
                          {{ isFasePasada(f.value) ? 'check' : f.icon }}
                        </mat-icon>
                      </div>
                      <span class="detail-step__label">{{ f.label }}</span>
                      <span class="detail-step__peso">{{ f.peso }}%</span>
                    </div>
                    <div class="detail-step-connector" *ngIf="!last"
                         [style.background-color]="isFasePasada(f.value) ? getFaseColor(f.value) : null">
                    </div>
                  </ng-container>
                </div>

                <div id="progress-chart" class="progress-chart"></div>
              </div>
            </div>
          </div>

          <div class="col-12 col-xl-4 mb-2">
            <div class="card info-panel h-100 mt-0">
              <div class="card-body p-3">
                <h2 class="panel-title mb-0 font-weight-bold">Esfuerzo de recursos</h2>
                <p class="panel-subtitle mb-2 text-muted">Horas reales vs horas planeadas</p>

                <div
                  *ngFor="let effort of detailProject.resourceEffort"
                  class="effort-item mb-2"
                >
                  <div class="d-flex justify-content-between align-items-center mb-1">
                    <span class="effort-name text-uppercase">{{ effort.name }}</span>
                    <strong class="effort-value">
                      {{ effort.used | number : "1.1-2" }} / {{ effort.total | number : "1.1-2" }} hrs.
                    </strong>
                  </div>

                  <div class="progress effort-track">
                    <div
                      class="progress-bar"
                      [ngClass]="'effort-bar--' + effort.tone"
                      [style.width.%]="getResourceProgress(effort)"
                    ></div>
                  </div>
                </div>

                <div class="efficiency-box text-center">
                  <span class="small text-uppercase font-weight-bold text-muted d-block">Resumen de esfuerzo</span>
                  <span class="efficiency-value">{{ detailProject.horasReales | number : "1.1-2" }} </span>
                  <span class="text-muted"> Hrs. acumuladas reales</span> /
                  <span class="efficiency-value">{{ detailProject.horasTotales | number : "1.1-2" }} </span>
                  <span class="text-muted"> Hrs. planeadas</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="card detail-surface m-1">
      <div class="card-body p-3">
        <div class="d-flex flex-wrap align-items-center justify-content-between mb-2">
          <div>
            <h2 class="panel-title mb-1 font-weight-bold">Historial de progreso</h2>
            <p class="panel-subtitle mb-0 text-muted">
              Comentarios y avances registrados del proyecto.
            </p>
          </div>
        </div>

        <div class="table-responsive">
          <table class="table table-hover table-sm mb-0 history-table">
            <thead>
              <tr>
                <th class="history-date-col">Fecha</th>
                <th>Avance</th>
                <th class="history-fase-col">Fase / Subfases</th>
                <th>Responsable</th>
                <th>Detalle de actualización</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of detailProject.history">
                <td class="history-date-col">{{ item.date }}</td>
                <td class="history-progress font-weight-bold">{{ item.progress }}%</td>
                <td class="history-fase-col">
                  <span class="hist-fase-badge"
                        [style.background-color]="getFaseLight(item.fase)"
                        [style.color]="getFaseColor(item.fase)"
                        [style.border-color]="getFaseColor(item.fase)">
                    <mat-icon class="hist-fase-icon">{{ getFaseIcon(item.fase) }}</mat-icon>
                    {{ getFaseLabel(item.fase) }}
                  </span>
                  <div class="hist-dev-pct" *ngIf="item.fase === 'DESARROLLO' && item.avanceDesarrollo != null"
                       [style.color]="getFaseColor('DESARROLLO')">
                    <mat-icon class="hist-dev-icon">trending_up</mat-icon>
                    Dev: {{ item.avanceDesarrollo }}%
                  </div>
                  <div class="hist-subfases" *ngIf="item.subfases.length">
                    <span *ngFor="let sf of item.subfases"
                          class="hist-sf-chip"
                          [class.hist-sf-chip--done]="sf.completado"
                          [class.hist-sf-chip--opcional]="sf.opcional">
                      {{ sf.nombre }}
                    </span>
                  </div>
                </td>
                <td>
                  <div class="d-flex align-items-center">
                    <img [src]="item.avatar" [alt]="item.owner" class="table-avatar rounded-circle" />
                    <span class="ml-2">{{ item.owner }}</span>
                  </div>
                </td>
                <td class="font-small">{{ item.detail }}</td>
              </tr>
              <tr *ngIf="!isLoading && detailProject.history.length === 0">
                <td colspan="5" class="text-center">No hay comentarios registrados para este proyecto.</td>
              </tr>
              <tr *ngIf="isLoading">
                <td colspan="5" class="text-center">Cargando detalle del proyecto...</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </section>
  </div>
</div>
